import React from "react";
import UpcomingList from "@/pages/UpcomingList";
export default function UpcomingReceivables() {
  return <UpcomingList kind="income" title="Yaklaşan Tahsilatlar" subtitle="Bekleyen Gelirler" testidPrefix="urec" />;
}
